/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

export enum DelayedDownloadingType {
    Operators = 'OPERATORS',
    Companies = 'COMPANIES',
    Stores = 'STORES',
    Cashboxes = 'CASHBOXES',
    Documents = 'DOCUMENTS',
    Devices = 'DEVICES',
    ReportByDay = 'REPORT_CASH_BOX_DAY',
    ReportByCashbox = 'REPORT_CASH_BOX',
}

export const DELAYED_DOWNLOADINGS_TYPE_TO_FILE_NAME_PREFIX: { [key in DelayedDownloadingType]: string } = {
    [DelayedDownloadingType.Operators]: 'operatorsList',
    [DelayedDownloadingType.Companies]: 'taxpayersList',
    [DelayedDownloadingType.Stores]: 'objectsList',
    [DelayedDownloadingType.Cashboxes]: 'cashboxesList',
    [DelayedDownloadingType.Documents]: 'receiptsList',
    [DelayedDownloadingType.Devices]: 'tokensList',
    [DelayedDownloadingType.ReportByDay]: 'reportByDay',
    [DelayedDownloadingType.ReportByCashbox]: 'reportByCashbox',
};

export enum DelayedDownloadingStatus {
    Created = 'CREATED',
    InProgress = 'IN_PROGRESS',
    Ready = 'READY',
    Error = 'ERROR',
}

export enum LazyLoadingErrorTypes {
    MAX_ROWS_COUNT = 'MAX_ROWS_COUNT',
}

export interface DelayedDownloadingsListItemDto {
    type: DelayedDownloadingType;
    name: string;
    id: number;
    requestedDateAtUtc: string;
    status: DelayedDownloadingStatus;
    errorMessage?: LazyLoadingErrorTypes;
}

export interface FileInfo {
    fileNameS3: string;
    fileNameForUser: string;
    id: number;
}

export interface RequestToCreateExcelDto {
    requestedDateAtUtc: string;
    id: number;
    name: string;
    status: string;
    type: string;
}
